import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { OmitProperties } from '../../osc-utils/types/omit-properties';

@Injectable()
export class DialogService {
  public constructor(public dialog: MatDialog) {}

  public openDialog<T, TInput, TResult>(component: ComponentType<T> | TemplateRef<T>, data: TInput,
                      additionalConfig?: OmitProperties<MatDialogConfig<TInput>, 'data' | 'panelClass'>): MatDialogRef<T, TResult> {
    const dialogConfig: MatDialogConfig<TInput> = this.getDialogConfig<TInput>('osc-ref-dialog', data, additionalConfig);
    return this.dialog.open(component, dialogConfig);
  }

  public openXlDialog<T, TInput, TResult>(component: ComponentType<T> | TemplateRef<T>, data: TInput,
                      additionalConfig?: OmitProperties<MatDialogConfig<TInput>, 'data' | 'panelClass'>): MatDialogRef<T, TResult> {
    const dialogConfig: MatDialogConfig<TInput> = this.getDialogConfig<TInput>('osc-ref-dialog--xl', data, additionalConfig);
    return this.dialog.open(component, dialogConfig);
  }

  public openFullScreenDialog<T, TInput, TResult>(component: ComponentType<T> | TemplateRef<T>, data: TInput,
                      additionalConfig?: OmitProperties<MatDialogConfig<TInput>, 'data' | 'panelClass'>): MatDialogRef<T, TResult> {
    const dialogConfig: MatDialogConfig<TInput> = this.getDialogConfig<TInput>('osc-ref-dialog--full-screen', data, additionalConfig);
    dialogConfig.minWidth = '100vw';
    dialogConfig.height = '100vh';
    return this.dialog.open(component, dialogConfig);
  }

  public openDialogWithCustomStyles<T, TInput, TResult>(component: ComponentType<T> | TemplateRef<T>, data: TInput, panelClass: string,
                      additionalConfig?: OmitProperties<MatDialogConfig<TInput>, 'data' | 'panelClass'>): MatDialogRef<T, TResult> {
    const dialogConfig: MatDialogConfig<TInput> = this.getDialogConfig<TInput>(panelClass, data, additionalConfig);
    return this.dialog.open(component, dialogConfig);
  }

  private getDialogConfig<TInput>(panelClass: string, data: TInput,
                      additionalConfig?: OmitProperties<MatDialogConfig<TInput>, 'data' | 'panelClass'>): MatDialogConfig<TInput> {
    const dialogConfig: MatDialogConfig<TInput> = additionalConfig ? { ...additionalConfig } : new MatDialogConfig<TInput>();
    dialogConfig.panelClass = panelClass;
    dialogConfig.data = data;
    return dialogConfig;
  }
}
